module.exports = __webpack_public_path__ + "media/src/images/logo-1c43d4f659f3a6ef624c6111d2d0c1ee.png";